import React from 'react';
import { useMounted } from '@homesusa/core';
import { FetchData, FetchDataDownloading, GridResponse } from '../interfaces';

export const useFetchData = <T>(
  getGridData: (props: FetchDataDownloading) => Promise<GridResponse<T>>
): {
  fetchData: (props: FetchData) => Promise<void>;
  fetchDataForDownloading: (sortBy?: string) => Promise<T[]>;
  data: GridResponse<T>;
} => {
  const mounted = useMounted();
  const [data, setData] = React.useState<GridResponse<T>>({
    data: [],
    total: 0
  });

  const fetchData = React.useCallback(
    async (props: FetchData): Promise<void> => {
      const response = await getGridData({ ...props, isForDownloading: false });
      if (mounted.current && response) {
        setData(response);
      }
    },
    [getGridData, mounted]
  );

  const fetchDataForDownloading = React.useCallback(
    async (sortBy?: string): Promise<T[]> => {
      if (data.total <= 0) {
        return [];
      }

      const response = await getGridData({
        pageSize: 1,
        pageIndex: 0,
        isForDownloading: true,
        sortBy
      });
      return response.data;
    },
    [getGridData, data.total]
  );

  return {
    data,
    fetchData,
    fetchDataForDownloading
  };
};
